import { render, staticRenderFns } from "./surface_nav.vue?vue&type=template&id=5ef5a5cd&scoped=true&"
import script from "./surface_nav.vue?vue&type=script&lang=js&"
export * from "./surface_nav.vue?vue&type=script&lang=js&"
import style0 from "./surface_nav.vue?vue&type=style&index=0&id=5ef5a5cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5a5cd",
  null
  
)

export default component.exports